import styled from "styled-components"

export const LabelDescription = styled.p`
  color: ${({ theme }) => theme.text.normal};
  font-size: 15px;
  font-weight: 500;

  margin: 4px 0 0;
`
